import {omneticApi} from '@dms/api/base';

/** Local transport state, scoped to the Redux store and reset with the API cache. */
export const appSyncConnectionApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getAppSyncConnection: build.query<{reconnectCount: number}, void>({
      queryFn: () => ({data: {reconnectCount: 0}}),
      keepUnusedDataFor: 0,
    }),
  }),
});
